import {
  CLEAR_WAITING_LIST_INFO,
  CLEAR_WAITING_LIST_TIMES,
  SET_WAITING_LIST_INFO,
  SET_WAITING_LIST_TIMES,
} from '../constants';
import { checkStatus, handleRequestError } from '../utils/helpers';
import config from '../../config';

export const clearWaitingListInfo = () => ({
  type: CLEAR_WAITING_LIST_INFO,
});

export const setWaitingListInfo = (shopId, barberId, serviceIds, numberInLine) => ({
  type: SET_WAITING_LIST_INFO,
  payload: {
    shopId,
    barberId,
    serviceIds: serviceIds.join(';'),
    numberInLine,
  },
});

export const clearWaitingListTimes = () => ({
  type: CLEAR_WAITING_LIST_TIMES,
});

const setWaitingListTimes = payload => ({
  type: SET_WAITING_LIST_TIMES,
  payload,
});

export const fetchWaitingListTimes = (waitingListCustomerId, slotId) => (dispatch) => {
  const url = `${config.url}/customer/waiting-list-slot-times/${waitingListCustomerId}/${slotId}`;
  return fetch(url)
    .then(checkStatus)
    .then(response => dispatch(setWaitingListTimes(response)))
    .catch(handleRequestError(dispatch));
};



// WEBPACK FOOTER //
// ./src/app/waitingList/actions.js